import classNames from 'classnames/bind';
import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet';

import Controller from './Controller';
import Dashboards from './Dashboards';
import styles from './index.module.scss';
import Map from './Map';
import SideBar from './SideBar';
import Windows from './Windows';

import BottomBar from '@/components/ui/BottomBar';
import Callout from '@/components/ui/Callout';
import ContainerFullHeight from '@/components/ui/ContainerFullHeight';
import MapSelector from '@/components/ui/MapSelector';
import TopBar from '@/components/ui/TopBar';
import ZonesSelector from '@/components/ui/ZonesSelector';
import { MessageContext } from '@/helpers/MessageProvider';
import useLoadRobots from '@/hooks/useLoadRobots';
import useLoadUser from '@/hooks/useLoadUser';
import useTracer from '@/hooks/useTracer';
import useZoneObserver from '@/hooks/useZoneObserver';

const cx = classNames.bind(styles);

const Page = () => {
  const { subscribeTelemetry } = useContext(MessageContext);

  // OlMap 초기화 완료 여부
  // Dashboards 컴포넌트(Frame)에서 OlMap.getMap()을 사용하므로
  // Map 컴포넌트가 완전히 초기화된 후에 Dashboards를 렌더링해야 함
  // 그렇지 않으면 타이밍 이슈로 인해 getMap()이 null을 반환할 수 있음
  const [isMapInitialized, setMapInitialized] = useState(false);

  // 계정 조회
  useLoadUser();
  // 로봇내역 조회
  useLoadRobots([], subscribeTelemetry);
  useTracer();
  useZoneObserver();

  // Map 컴포넌트 초기화 완료 콜백
  const handleMapInitialized = () => {
    setMapInitialized(true);
  };

  return (
    <>
      <Helmet>
        <title>M1UCS | Control Center</title>
      </Helmet>
      <ContainerFullHeight className={cx('container')}>
        <TopBar>
          <MapSelector />
          <ZonesSelector />
        </TopBar>
        <div className={cx('content')}>
          {/* Map 초기화 완료 시 handleMapInitialized 콜백 호출 */}
          <Map onInitialized={handleMapInitialized} />
          <div className={cx('leftTop')}>
            {/* Map 초기화 완료 후에만 Dashboards 렌더링 (타이밍 이슈 방지) */}
            {isMapInitialized && <Dashboards />}
          </div>
          <div className={cx(['centerBottom'])}>
            <Controller />
          </div>
          <div className={cx('right')}>
            <SideBar />
          </div>
          <Windows />
        </div>
        <BottomBar />
        <Callout />
      </ContainerFullHeight>
    </>
  );
};

export default Page;
